export const selectMode = (state) => state.isNightMode;
export const selectPageLoading = (state) => state.pageLoading;
export const selectSuccessMessage = (state) => state.successMessage;
export const selectErrorMessage = (state) => state.errorMessage;
export const selectErrorMessageErrors = (state) => selectErrorMessage(state).errors;
export const selectBreadCrumbParams = (state) => state.breadcrumbParams;
export const selectCallEndedStatus = (state) => state.endedStatus;
export const selectGenerateReportEndedStatus = (state) => state.generateReportEndedStatus;
export const selectActiveMenu = (state) => state.activeMenu;
